// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages{
    /* //padding-left: 220px; */
    transition: width 0.3s linear;
    /* //overflow-y:scroll; */
    width: 100%;
    padding-block-start: 40px;
    padding-bottom: 0px;
    height:calc(100vh - 50px);
    overflow-x: hidden;
    scrollbar-width: thin;
}
.sidebar .sidebar-open .pages{
    padding-left: 40px;
}
.iframe-panels {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 20px;
    margin-top: 20px;
    padding:10px;
  }
  
  .device-panel {
    background: #fff;
    border: 1px solid #ccc;
    /* padding: 10px; */
    /* height: 300px; adjust as needed */
    display: flex;
    flex-direction: column;
  }
  
  .device-panel h6 {
    margin-bottom: 10px;
    font-weight: 600;
    text-align: center;
  }
  
  .device-panel iframe {
    flex-grow: 1;
    width: 100%;
    height: 100%;
    border: none;
  }
  
  
.row{
    width: 100%;
    display: flex;
    justify-content: flex-end;
}
.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    padding-right: 32px;
    color: black !important;
}
.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {
    color: black !important;
}
.panel{
    
    background: white;
    /* width: 300px; */
    height: 100%;
    /* border-radius: 10px; */
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    margin-left: 20px;
}
.head {
  padding-left: 20px;
  font-family: sans-serif ;
  font-size: 25px;
  margin-top: 20px;
  margin-bottom:0;
  
}`, "",{"version":3,"sources":["webpack://./src/app/Pages/CurrentShift/CurrentShift.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;;AAGF;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,yCAAyC;IACzC,iBAAiB;AACrB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;;AAEjB","sourcesContent":[".pages{\n    /* //padding-left: 220px; */\n    transition: width 0.3s linear;\n    /* //overflow-y:scroll; */\n    width: 100%;\n    padding-block-start: 40px;\n    padding-bottom: 0px;\n    height:calc(100vh - 50px);\n    overflow-x: hidden;\n    scrollbar-width: thin;\n}\n.sidebar .sidebar-open .pages{\n    padding-left: 40px;\n}\n.iframe-panels {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n    padding:10px;\n  }\n  \n  .device-panel {\n    background: #fff;\n    border: 1px solid #ccc;\n    /* padding: 10px; */\n    /* height: 300px; adjust as needed */\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .device-panel h6 {\n    margin-bottom: 10px;\n    font-weight: 600;\n    text-align: center;\n  }\n  \n  .device-panel iframe {\n    flex-grow: 1;\n    width: 100%;\n    height: 100%;\n    border: none;\n  }\n  \n  \n.row{\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n}\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n    padding-right: 32px;\n    color: black !important;\n}\n.css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {\n    color: black !important;\n}\n.panel{\n    \n    background: white;\n    /* width: 300px; */\n    height: 100%;\n    /* border-radius: 10px; */\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n    margin-left: 20px;\n}\n.head {\n  padding-left: 20px;\n  font-family: sans-serif ;\n  font-size: 25px;\n  margin-top: 20px;\n  margin-bottom:0;\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
